/**
 *
 * Question
 *
 */

import { HtmlMixin } from '@/mixins/MtEditor/HtmlMixin';

export const QaQuestionContentMixin = {
  name: 'QaQuestionContentMixin',

  mixins: [HtmlMixin],

  computed: {
    //
    c_objQaContent() {
      //
    },

    c_qaContent() {
      return this.safeHtmlFilter(this.c_objQaContent);
    },
  },

  methods: {
    clickQaContent(e) {
      this.$emit('click-qa-content', e);
    },
  },
};
